import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { EtollStatusHttpService } from '@layout/vehicle/http-services/etoll-status-http.service';
import { etollBalance } from '@layout/vehicle/http-services/responses/getETollBalance.response';
import { PermissionService } from '@shared/services/permission.service';

const LOCAL_STORAGE_SELECTED_BALANCE_ID = 'SELECTED_ETOLL_BALANCE_ID';

@Component({
  selector: 'app-etoll-dropdown-balance',
  templateUrl: './etoll-dropdown-balance.component.html',
  styleUrls: ['./etoll-dropdown-balance.component.scss'],
})
export class EtollDropdownBalanceComponent implements OnInit {

  @Output() private onSelectedBalance$: EventEmitter<etollBalance> = new EventEmitter();

  public etollSelectedBalance: number;
  public isETollRegistered: boolean;
  public isLoading: boolean;
  public list: etollBalance[] = [];

  private get pinnedBalanceAccId(): string {
    return localStorage.getItem(LOCAL_STORAGE_SELECTED_BALANCE_ID) as string;
  }

  constructor(
    private eTollStatusService: EtollStatusHttpService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.isETollRegistered = this.permissionService.hasEToll();

    if (this.isETollRegistered) {
      this.loadETollData();
    }
  }

  private getBalanceById(id: number): etollBalance {
    const item = this.list.find(item => item.IdETollBalance === id);
    return item as etollBalance;
  }

  public onChangeSelectedBalance(data: number): void {
    localStorage.setItem(LOCAL_STORAGE_SELECTED_BALANCE_ID, `${ data }`);
    const balance = this.getBalanceById(data);
    this.onSelectedBalance$.emit(balance);
  }

  private loadETollData(): void {
    this.isLoading = true;
    this.eTollStatusService.getBalance().subscribe(response => this.processETollData(response.Result?.Result));
  }

  private processETollData(list?: etollBalance[]): void {
    this.isLoading = false;
    if (list) {
      this.list = list;
    }
    this.selectPinnedBalanceInit();
  }

  private selectPinnedBalanceInit(): void {
    if (this.list?.length) {
      let selectedBalance: etollBalance = null as any;   
      if (this.pinnedBalanceAccId) {
        selectedBalance = this.list.find(item => item.IdETollBalance === Number(this.pinnedBalanceAccId)) as etollBalance;
      }
      if (!this.pinnedBalanceAccId || (this.pinnedBalanceAccId && !selectedBalance)) {
        const [firstBalance] = this.list;
        selectedBalance = firstBalance;
      }
      if (selectedBalance) {
        this.etollSelectedBalance = selectedBalance.IdETollBalance;
        this.onChangeSelectedBalance(this.etollSelectedBalance);
      }
    }
  }

}
